import styled from 'styled-components';

import { THighlightedSpan } from '@/shared/components/ui/highlighted-text/highlighted-text.types';

export const HighlightedSpan = styled.span<THighlightedSpan>`
  && {
    background-color: ${({ $isHighlighted, theme }) =>
      $isHighlighted ? theme.palette.common.orange : 'transparent'};
    border-radius: 0;
  }
`;
